export const AppState = {
  LocateUser: 0,
  ConfirmCustomer: 1,
  ConfirmVehicle: 2,
  SelectService: 3,
  SelectDestination: 4,
  LocatingProvider: 5,
  ConfirmInformation: 6,
  PaymentRequired: 7,
  ProviderEnroute: 8,
  Feedback: 9,
  Temp: 10,
  Blank: -1,
  TTLocateUser: 12,
  MemberInformation: 201,
  AccidentConfirmed: 202,
  MemberSearch: 211,
  PartnerPromotion: 225,
  // TowReasons: 212,
};
